import React from 'react';
import {
    Box,
    CircularProgress,
    Typography,
    Alert,
} from '@mui/material';
import { useTenantPropertyLocks } from '../../hooks/usePropertyLocks';
import SmartLockCard from './SmartLockCard';

const SmartLocksList = ({ propertyId }) => {
    const { locks, loading, error } = useTenantPropertyLocks(propertyId);

    if (loading) {
        return (
            <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
                <CircularProgress size={24} />
                <Typography variant="body2" sx={{ ml: 2 }}>Loading smart locks...</Typography>
                </Box>
        );
    }

    if (error) {
        return (
            <Alert severity="error" sx={{ mb: 2 }}>
                Error loading smart locks: {error}
            </Alert>
        );
    }

    if (!locks || locks.length === 0) {
        return (
            <Alert severity="info" sx={{ mb: 2 }}>
                No smart locks found for this property.
            </Alert>
        );
    }

    return (
        <Box sx={{overflow:"scroll", maxHeight:"220px"}}>
            {locks.map((lock) => (
                <SmartLockCard key={lock.lockId} lock={lock} />
            ))}
        </Box>
    );
};

export default SmartLocksList;
